module.exports = __webpack_public_path__ + "static/media/1717128338774-min.aea7991a.JPG";